import { Box, Typography, Card, CardContent } from '@mui/material';
import { Icon } from '@iconify/react';

const features = [
  {
    icon: 'solar:camera-bold',
    title: 'AI Food Logging',
    description: 'Snap a photo and let AI identify your meals instantly',
  },
  {
    icon: 'solar:chart-bold',
    title: 'Nutrition Insights',
    description: 'Track macros, calories, and get personalized insights',
  },
  {
    icon: 'solar:cup-hot-bold',
    title: 'Water Tracking',
    description: 'Stay hydrated with easy water intake monitoring',
  },
  {
    icon: 'solar:calendar-bold',
    title: 'Calendar View',
    description: 'Visualize your eating patterns over time',
  },
  {
    icon: 'solar:bell-bold',
    title: 'Smart Reminders',
    description: 'Get notified to log meals and stay on track',
  },
  {
    icon: 'solar:moon-bold',
    title: 'Dark Mode',
    description: 'Toggle between dark and light mode for comfort',
  },
];

export const FeaturesGrid = () => {
  return (
    <Box sx={{ mt: { xs: 10, md: 14 } }}>
      <Typography
        variant="h2"
        sx={{
          textAlign: 'center',
          mb: 6,
        }}
      >
        Everything You Need
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
          },
          gap: 3,
        }}
      >
        {features.map((feature, index) => {
          return (
            <Card
              key={index}
              sx={{
                height: '100%',
                backgroundColor: 'background.paper',
                border: '1px solid',
                borderColor: 'grey.200',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  borderColor: 'primary.main',
                  transform: 'translateY(-4px)',
                  boxShadow: '0 12px 24px rgba(96, 210, 148, 0.12)',
                },
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 3,
                    backgroundColor: 'rgba(96, 210, 148, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2,
                  }}
                >
                  <Icon icon={feature.icon} width={24} style={{ color: '#36C65A' }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    fontSize: '1.125rem',
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ lineHeight: 1.6 }}
                >
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
};
